import { createStore, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import ReduxThunk from 'redux-thunk'
import createRootReducer from '../reducers'

import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'

export const history = createBrowserHistory({ basename: '/' })

// If the argument is supplied, then we're in production
export default function makeStore(productionConfig, initialState = {}) {
  if (productionConfig) {
    const {
      sentry,
    } = productionConfig
    const createStoreWithMiddleWare = applyMiddleware(ReduxThunk, routerMiddleware(history))(createStore)
    return createStoreWithMiddleWare(createRootReducer(history), initialState, sentry)
  } else {
    let middleware = [
      ReduxThunk,
      routerMiddleware(history),
    ]

    if (process.env.NODE_ENV !== 'test') {
      middleware = [...middleware, createLogger()]
    }

    const createStoreWithMiddleWare = applyMiddleware(...middleware)(createStore)
    return createStoreWithMiddleWare(createRootReducer(history), initialState)
  }
}
